// project import
import mobileApplications from './mobileApplications';
import order from './order';
import admin from './admin';
import dashboard from './dashboard';
import inventory from './inventory';

// ==============================|| MENU ITEMS ||============================== //

export const navigation = {
  items: [dashboard, admin, mobileApplications, order, inventory]
};
